import { render, staticRenderFns } from "./module-sidebar.vue?vue&type=template&id=56fc2330&scoped=true"
import script from "./module-sidebar.vue?vue&type=script&lang=js"
export * from "./module-sidebar.vue?vue&type=script&lang=js"
import style0 from "./module-sidebar.vue?vue&type=style&index=0&id=56fc2330&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56fc2330",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('56fc2330')) {
      api.createRecord('56fc2330', component.options)
    } else {
      api.reload('56fc2330', component.options)
    }
    module.hot.accept("./module-sidebar.vue?vue&type=template&id=56fc2330&scoped=true", function () {
      api.rerender('56fc2330', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pageconfig/components/module-sidebar.vue"
export default component.exports